import React, { useState, useMemo, useContext , useRef, useEffect} from "react";
import _ from "lodash";
import useApi from "api/useApi";
import styled from "styled-components";
import UploadData from "components/Patrimoine/UploadData";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import SearchIcon from "@mui/icons-material/Search";
import UserService from "services/UserService";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import AddMeters from "./Actions/AddMeters";
import EditMeters from "./Actions/EditMeters";
import DeleteMeters from "./Actions/DeleteMeters";
import ExportTableToCSV from "components/ExportTableToCSV/ExportTableToCSV";
import { compte } from "variables/patrimoine.js";
import { getAccountMeters } from "services/ConfigServices";

const NoData = styled.p`
  font-size: 14px;
  font-weight: 600;
  margin-top: 20px;
  opacity: 1;
`;

const SelectionText = styled.p`
  font-size: 14px;
  margin-top: 8px;
  margin-right: 20px;
  opacity: 1;

`;



export default function useMetersTable(
  energy,
  parameters,
  addUserDialog,
  buttonTitle,
  dialogTitle,
  listTitle
) {
  const permis = JSON.parse(localStorage.getItem('permission')) || [];
  const realestateupdate = permis.includes("realestate_update");
  const appContext = useContext(AdvancedSearchContext);
  const { chartIdGroup } = appContext;
  const [meters, setMeters] = useState([]);
  const [totalRows, setTotalRows] = useState(0);

  const url = getAccountMeters(chartIdGroup, energy);

  const { results, loading, error, refetch, invalidate } = useApi(url, {
    method: "GET",
    headers: {
      Authorization: `Bearer ${UserService.getToken()}`,
    },
  });

  const [open, setOpen] = useState(false);

  const usePrevious = (value) => {
    const ref = useRef();
    useEffect(() => {
      ref.current = value;
    },[value]);
    return ref.current;
  };

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const refreshTable = () => {
    setMeters([]);
    refetch();
  };

  // ----------------------------------------------------------

  const [filterText, setFilterText] = useState("");
  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);

  const UploadButton = styled.div`
    margin-left: 0px;
    &:hover {
      cursor: pointer;
    }
  `;

  const TableName = styled.h1`
    margin-right: auto;
    margin-left: -8px;
    font-size: 1.3rem;
    font-weight: 500;
  `;

  const FilterComponent = ({  onFilter, onClear }) => (
    <>
      <div style={{ marginTop: "-7px" }}>
        <TextField
          type="search"
          variant="outlined"
          margin="normal"
          size="small"
          //autoFocus={filterText!==usePrevious(filterText)}
          autoFocus="true"
          value={filterText}
          onChange={onFilter}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
        />
      </div>
    </>
  );

  const statusData = [
    { name: "Actif", id: "on" },
    { name: "Résilié", id: "off" },
  ];

  // console.log(filterText);
  // console.log();

  const filteredItems = _.get(
    results,
    `meters`,
    []
  ).filter(
    (item) =>
      (item.details.clef && typeof item.details.clef == 'string' && item.details.clef.toLowerCase().includes(filterText.toLowerCase())) ||
    (item.details.serialnumber && typeof item.details.serialnumber == 'string' && item.details.serialnumber.toLowerCase().includes(filterText.toLowerCase())) ||
      (item.details.dso && typeof item.details.dso == 'string' && item.details.dso.toLowerCase().includes(filterText.toLowerCase())) ||
      (item.details.cja && typeof item.details.cja == 'string' && item.details.cja.toLowerCase().includes(filterText.toLowerCase())) ||
      (item.details.acheminement && typeof item.details.acheminement == 'string' && item.details.acheminement.toLowerCase().includes(filterText.toLowerCase())) ||
      (item.details.profil && typeof item.details.profil == 'string' && item.details.profil.toLowerCase().includes(filterText.toLowerCase())) ||
      (item.details.comments && typeof item.details.comments == 'string' && item.details.comments.toLowerCase().includes(filterText.toLowerCase())) ||
      (item.details.car && typeof item.details.car == 'string' && item.details.car.toLowerCase().includes(filterText.toLowerCase())) ||
      (item.details.name && typeof item.details.name == 'string' && item.details.name.toLowerCase().includes(filterText.toLowerCase())) ||
      (item.details.usagecode && typeof item.details.usagecode == 'string' && item.details.usagecode.toLowerCase().includes(filterText.toLowerCase())) ||
      (item.details.description && typeof item.details.description == 'string' && item.details.description.toLowerCase().includes(filterText.toLowerCase())) ||
      (item.details.segment && typeof item.details.segment == 'string' && item.details.segment.toLowerCase().includes(filterText.toLowerCase())) ||
      (item.meternumber && typeof item.meternumber == 'string' && item.meternumber.toLowerCase().includes(filterText.toLowerCase())) ||
      (item.details.status && statusData.find((x) => x.id == item.details.status) && statusData.find((x) => x.id == item.details.status).name.toLowerCase().includes(filterText.toLowerCase()))
  );

  const subHeaderComponentMemo = useMemo(() => {
    const handleClear = () => {
      if (filterText) {
        setResetPaginationToggle(!resetPaginationToggle);
        setFilterText("");
      }
    };
    const onFilterText = (e) => {
      setFilterText(e.target.value)
    };
   
    let exportarray = [];
    if (energy === 'electricity') {
      exportarray = meters.map((item) => {
        let metertoexport = {};
        metertoexport[compte.energy.electricity.meters.key] = item.details?.clef || "";
        metertoexport[compte.energy.electricity.meters.meternumber] = item.meternumber;
        metertoexport[compte.energy.electricity.meters.serialnumber] = item.details?.serialnumber || "";
        metertoexport[compte.energy.electricity.meters.status] = item.details?.status === "on" ? 'Actif' : "Résilié";
        metertoexport[compte.energy.electricity.meters.name] = item.details?.name || "";
        metertoexport[compte.energy.electricity.meters.segment] = item.details?.segment  || "";
        metertoexport[compte.energy.electricity.meters.address] = item.details?.address?.description  || "";
        metertoexport[compte.energy.electricity.meters.acheminement] = item.details?.acheminement  || "";
        metertoexport[compte.energy.electricity.meters.powersubscriptionhph] = item.details?.powersubscriptionhph || "";
        metertoexport[compte.energy.electricity.meters.powersubscriptionhch] = item.details?.powersubscriptionhch || "";
        metertoexport[compte.energy.electricity.meters.powersubscriptionhpe] = item.details?.powersubscriptionhpe || "";
        metertoexport[compte.energy.electricity.meters.powersubscriptionhce] = item.details?.powersubscriptionhce || "";
        metertoexport[compte.energy.electricity.meters.powersubscriptionpointe] =  item.details?.powersubscriptionpointe || "";
        metertoexport[compte.energy.electricity.meters.powersubscriptionbase] = item.details?.powersubscriptionbase || "";
        metertoexport[compte.energy.electricity.meters.monthlyconsumption] = item.details?.monthlyconsumption === true ? 'Oui' : 'Non';
        metertoexport[compte.energy.electricity.meters.dailyconsumption] = item.details?.dailyconsumption === true ? 'Oui' : 'Non';
        metertoexport[compte.energy.electricity.meters.loadcurve] = item.details?.loadcurve === true ? 'Oui' : 'Non';
        metertoexport[compte.energy.electricity.meters.contractualdata] = item.details?.contractualdata === true ? 'Oui' : 'Non';
        metertoexport[compte.energy.electricity.meters.utilitydata] = item.details?.utilitydata === true ? 'Oui' : 'Non';
        metertoexport[compte.energy.electricity.meters.comments] = item.details?.comments || "";
        metertoexport[compte.energy.electricity.meters.description] = item.details?.description || "";
        metertoexport[compte.energy.electricity.meters.usagecode] = item.details?.usagecode || "";
        return metertoexport;
      });
    }
    else if (energy === 'gas') {
      exportarray = meters.map((item) => {
        let metertoexport = {};
        metertoexport[compte.energy.gas.meters.key] = item.details?.clef || "";
        metertoexport[compte.energy.gas.meters.meternumber] = item.meternumber;
        metertoexport[compte.energy.gas.meters.serialnumber] = item.details?.serialnumber || "";
        metertoexport[compte.energy.gas.meters.status] = item.details?.status === "on" ? 'Actif' : "Résilié";
        metertoexport[compte.energy.gas.meters.name] = item.details?.name  || "";
        metertoexport[compte.energy.gas.meters.cja] = item.details?.cja  || "";
        metertoexport[compte.energy.gas.meters.address] = item.details?.address?.description  || "";
        metertoexport[compte.energy.gas.meters.profil] = item.details?.profil  || "";
        metertoexport[compte.energy.gas.meters.car] = item.details?.car || "";
        metertoexport[compte.energy.gas.meters.monthlyconsumption] = item.details?.monthlyconsumption === true ? 'Oui' : 'Non';
        metertoexport[compte.energy.gas.meters.dailyconsumption] = item.details?.dailyconsumption === true ? 'Oui' : 'Non';
        metertoexport[compte.energy.gas.meters.loadcurve] = item.details?.loadcurve === true ? 'Oui' : 'Non';
        metertoexport[compte.energy.gas.meters.contractualdata] = item.details?.contractualdata === true ? 'Oui' : 'Non';
        metertoexport[compte.energy.gas.meters.utilitydata] = item.details?.utilitydata === true ? 'Oui' : 'Non';
        metertoexport[compte.energy.gas.meters.comments] = item.details?.comments || "";
        metertoexport[compte.energy.gas.meters.description] = item.details?.description || "";
        metertoexport[compte.energy.gas.meters.usagecode] = item.details?.usagecode  || "";
        return metertoexport;
      });
    }
    else if (energy === 'water') {
      exportarray = meters.map((item) => {
        let metertoexport = {};
        metertoexport[compte.energy.water.meters.key] = item.details?.clef || "";
        metertoexport[compte.energy.water.meters.meternumber] = item.meternumber;
        metertoexport[compte.energy.water.meters.serialnumber] = item.details?.serialnumber || "";
        metertoexport[compte.energy.water.meters.status] = item.details?.status === "on" ? 'Actif' : "Résilié";
        metertoexport[compte.energy.water.meters.name] = item.details?.name  || "";
        metertoexport[compte.energy.water.meters.diameter] = item.details?.diameter  || "";
        metertoexport[compte.energy.water.meters.address] = item.details?.address?.description  || "";
        metertoexport[compte.energy.water.meters.acheminement] = item.details?.acheminement  || "";
        metertoexport[compte.energy.water.meters.monthlyconsumption] = item.details?.monthlyconsumption === true ? 'Oui' : 'Non';
        metertoexport[compte.energy.water.meters.dailyconsumption] = item.details?.dailyconsumption === true ? 'Oui' : 'Non';
        metertoexport[compte.energy.water.meters.loadcurve] = item.details?.loadcurve === true ? 'Oui' : 'Non';
        metertoexport[compte.energy.water.meters.contractualdata] = item.details?.contractualdata === true ? 'Oui' : 'Non';
        metertoexport[compte.energy.water.meters.comments] = item.details?.comments || "";
        metertoexport[compte.energy.water.meters.description] = item.details?.description || "";
        metertoexport[compte.energy.water.meters.usagecode] = item.details?.usagecode  || "";
        return metertoexport;
      });
    }
    else {
      exportarray = meters.map((item) => {
        let metertoexport = {};
        metertoexport[compte.energy[energy].meters.key] = item.details?.clef || "";
        metertoexport[compte.energy[energy].meters.meternumber] = item.meternumber;
        metertoexport[compte.energy[energy].meters.serialnumber] = item.details?.serialnumber || "";
        metertoexport[compte.energy[energy].meters.status] = item.details?.status === "on" ? 'Actif' : "Résilié";
        metertoexport[compte.energy[energy].meters.name] = item.details?.name  || "";
        metertoexport[compte.energy[energy].meters.address] = item.details?.address?.description  || "";
        metertoexport[compte.energy[energy].meters.acheminement] = item.details?.acheminement  || "";
        metertoexport[compte.energy[energy].meters.monthlyconsumption] = item.details?.monthlyconsumption === true ? 'Oui' : 'Non';
        metertoexport[compte.energy[energy].meters.dailyconsumption] = item.details?.dailyconsumption === true ? 'Oui' : 'Non';
        metertoexport[compte.energy[energy].meters.loadcurve] = item.details?.loadcurve === true ? 'Oui' : 'Non';
        metertoexport[compte.energy[energy].meters.contractualdata] = item.details?.contractualdata === true ? 'Oui' : 'Non';
        metertoexport[compte.energy[energy].meters.comments] = item.details?.comments || "";
        metertoexport[compte.energy[energy].meters.description] = item.details?.description || "";
        metertoexport[compte.energy[energy].meters.usagecode] = item.details?.usagecode  || "";
        return metertoexport;
      });
    }

    return (
      <>
        <TableName>{""}</TableName>

        {meters && meters.length > 0 ? <SelectionText>
          <>
            {
              meters.length == 1 ? <>1 compteur sélectionné</> : <>{meters.length} compteurs sélectionnés</>
            }
          </>
        </SelectionText> : <></>}
        <FilterComponent
          key="FilterComponent"
          onFilter={onFilterText}
          onClear={handleClear}
     //     filterText={filterText}
        />
        {realestateupdate &&
          <>
            <UploadButton type="button">
              <AddMeters
                buttonTitle={buttonTitle}
                content={addUserDialog}
                dialogTitle={dialogTitle} />
            </UploadButton>
            <UploadButton type="button">
              <EditMeters refetch={refreshTable} meters={meters} disabled={!meters || meters.length < 1} energy={energy} parameters={parameters} />
            </UploadButton>
            <UploadButton type="button">
              <DeleteMeters refetch={refreshTable} meters={meters} disabled={!meters || meters.length < 1} energy={energy} />
            </UploadButton>

          </>
        }
        <UploadButton type="button" onClick={handleClear}>
          <ExportTableToCSV dataarray={exportarray} disabled={!meters || meters.length < 1} />
        </UploadButton>
      </>
    );
  }, [filterText, resetPaginationToggle, open, meters]);

  return {
    gridState: {
      defaultPageSize: 10,
      data: filteredItems,
      paginationTotalRows: totalRows,
      filterable: true,
      manual: true,
      paginationResetDefaultPage: resetPaginationToggle,
      subHeaderComponent: subHeaderComponentMemo,
      //onChangeRowsPerPage: handlePerRowsChange,
      //onChangePage: handlePageChange,
      //onSort: handleSort,
      loading,
      noDataComponent: <NoData></NoData>,
      paginationComponentOptions:
      {
        noRowsPerPage: false,
        rowsPerPageText: "Lignes par page",
        rangeSeparatorText: "sur",
        selectAllRowsItem: false,
        selectAllRowsItemText: "Selectionner toutes les lignes"
      }
      ,
    },
    error,
    refetch: refreshTable,
    invalidate,
    handleClose,
    setMeters,
  };
}
